import React from 'react';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const AuthRoute = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
    } else {
      navigate('/login');
    }
  }, []);

  return (
    <>
      {
        localStorage.getItem('token') && (<Outlet />)
      }

    </>
  )

};

export default AuthRoute;
